import styled from "styled-components";

import {
  useClearActiveAction,
  useStartRESignupActiveAction,
} from "Dashboard/components/WhatsNext/whatsNextStore";
import {
  FloatingButton,
  InnerWrapper,
  iconPaddingRight,
} from "NavBar/components/FloatingButtonPanel/ButtonStyles";
import IconWrapper from "NavBar/components/FloatingButtonPanel/IconWrapper";
import useIsSelected from "NavBar/components/useIsSelected";
import { navSectionKeys, useCreateSignupRef } from "NavBar/navBarStore";
import {
  useCloseNavIfOpen,
  useIsCreateSignupButtonFlashing,
} from "NavBar/stateHooks";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrSimpleReveal from "UI/FnrSimpleReveal";
import FnrTypography from "UI/FnrTypography";
import { navAccentColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";
import {
  useIsFocusVisible,
  useIsHovered,
} from "Utilities/Hooks/useIsHoverFocused";
import { addLeadingSlash } from "Utilities/stringTransformers";

import { useShowButtonText } from "./floatingSearchStore";
import {
  activeBackgroundColor,
  inactiveBackgroundColor,
} from "./styleConstants";

const importSignupsNew = () => import("Signups/SignupView/NewSignup");

const NewButton = () => {
  const normalizedTo = addLeadingSlash("signups/new");
  const isSelected = useIsSelected(normalizedTo);

  const clearActiveAction = useClearActiveAction();
  const isStartRESignupActive = useStartRESignupActiveAction();
  const isCreateSignupButtonFlashing = useIsCreateSignupButtonFlashing();
  const createSignupRef = useCreateSignupRef();
  const isHovered = Boolean(useIsHovered(createSignupRef));
  const isFocusVisible = Boolean(useIsFocusVisible(createSignupRef));
  const closeNavIfOpen = useCloseNavIfOpen();

  const handleClick = () => {
    window.fnReactBus.goToUrl(normalizedTo);
    closeNavIfOpen();
    // Don't clear action if in startRESignup flow - the template click will clear it
    if (!isStartRESignupActive) {
      clearActiveAction();
    }
  };

  const showButtonText = useShowButtonText();

  return (
    <FloatingButton
      ref={createSignupRef}
      onClick={handleClick}
      onMouseEnter={importSignupsNew}
      data-cy="NavBar_FloatingNewSignupButton"
      aria-current={isSelected ? "page" : undefined}
      $isSelected={isSelected}
      $glowColor={navAccentColors[navSectionKeys.signups][0]}
      $noGlow={!isSelected}
      $isFlashing={isCreateSignupButtonFlashing}
      $flashToColor={addOpacity(activeBackgroundColor, 0.7)}
      $backgroundColor={
        isSelected ? activeBackgroundColor : inactiveBackgroundColor
      }
    >
      <InnerWrapper>
        <IconWrapper $paddingRight={showButtonText ? iconPaddingRight : 0} $isSearchActive={!showButtonText}>
          <FnrContainedIcon
            icon="plus-circle fas"
            size="sm"
            color="textLight"
            backgroundColor="transparent"
            noPadding
            noAnimation
            shadow
          />
        </IconWrapper>
        <FnrSimpleReveal show={showButtonText}>
          <TextWrapper>
            <FnrTypography fontSize="13px" lineHeight={1} color="textLight" shadow noWrap>
              NEW
            </FnrTypography>
          </TextWrapper>
        </FnrSimpleReveal>
        <FnrSimpleReveal show={showButtonText && (isHovered || isFocusVisible)}>
          <FnrTypography fontSize="13px" lineHeight={1} color="textLight" shadow noWrap>
            SIGNUP
          </FnrTypography>
        </FnrSimpleReveal>
      </InnerWrapper>
    </FloatingButton>
  );
};

const TextWrapper = styled.div`
  padding-right: 4px;
`;

export default NewButton;
